




























import { Vue, Component, Prop } from 'vue-property-decorator';
import '../assets/icons/index';

@Component
export default class RkIcon extends Vue {
  @Prop({default: ''}) private icon!: string;
  @Prop({default: ''}) private size!: string;
  @Prop({default: false}) private loading!: boolean;
  @Prop({default: false}) private offset!: boolean;
}
